module.exports = __webpack_public_path__ + "static/media/texture (8).8dcb9a27.jpg";